import axios from 'axios';
import { getItemFromStorage } from '../services/utilService';
import { SetError, LogoutType } from '../store/actions/actionTypes';
import store from '../store';
import { BaseURL, status } from './constants';
const { dispatch } = store; // direct access to redux store.
const instance = axios.create({
    baseURL: BaseURL
});

// intercept requests and add authorization token if available
instance.interceptors.request.use(async (config) => {
    const auth = await getItemFromStorage('auth');

    if (auth && auth.access_token) {
        config.headers.Authorization = `${auth.token_type} ${auth.access_token}`;
    }
    return config;
});

instance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
  );

  const errorHandler = (error: any) => {
    if (isHandlerEnabled(error.config)) {
      // Handle errors
      if(error.request?.status === status.unAuthorized) {
        localStorage.clear();
        dispatch({type: LogoutType});
      }
     dispatch({type: SetError, payload: true});
    }
    return Promise.reject({ ...error })
  }
  
  const successHandler = (response: any) => {
    if (isHandlerEnabled(response.config)) {
      // Handle responses
      dispatch({type: SetError, payload: false});
    }
    return response
  }

  const isHandlerEnabled = (config: any) => {
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? 
      false : true
  }
export default instance;